import React, { useEffect, useState, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import "./course.css";
import Table from "./components/Table";
import useExcelParser from "./components/useExcelParser";
import { ValueContext } from "../../../Context";
import Loader from "../../../components/Loader";
import { API_BASE_URL, authFetch } from "../../../config/api";

function OtherCourse() {
  const { session, semester, code, title, unit } = useParams();
  const [students, setStudents] = useState([]);
  const { setAlert } = useContext(ValueContext);
  const { data, parseExcel } = useExcelParser();
  const [load, setLoad] = useState(false);

  const fetchStudentsByCourse = useCallback(
    async (withLoader = true) => {
      if (withLoader) setLoad(true);
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/class/${session}/${semester}/${code}`
        );
        if (response.status === 404) { setStudents([]); return; }
        if (!response.ok) throw new Error(`Failed to fetch students`);
        const json = await response.json();
        setStudents(Array.isArray(json) ? json : []);
      } catch (err) {
        console.error(err);
        setAlert(true, "Failed to fetch course students", "error");
      } finally {
        if (withLoader) setLoad(false);
      }
    },
    [session, semester, code, setAlert]
  );

  useEffect(() => {
    fetchStudentsByCourse(true);
  }, [fetchStudentsByCourse]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) parseExcel(file);
  };

  const handle_result_upload = async () => {
    if (!Array.isArray(data) || data.length === 0) {
      setAlert(true, "Upload an Excel file with student scores first", "error");
      return;
    }

    setLoad(true);
    try {
      const response = await authFetch(`${API_BASE_URL}/api/class/score`, {
        method: "POST",
        body: JSON.stringify({
          students: data,
          session,
          semester,
          course_code: code,
        }),
        headers: { "Content-Type": "application/json" },
      });

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Failed to save scores");
      }

      if (Number(json?.summary?.skipped) > 0) {
        setAlert(
          true,
          `${json.message} Check skipped rows before re-upload.`,
          "error"
        );
      } else {
        setAlert(true, "Scores added successfully", "success");
      }

      await fetchStudentsByCourse(false);
    } catch (err) {
      console.error(err);
      setAlert(true, err.message || "Error uploading scores", "error");
    } finally {
      setLoad(false);
    }
  };
  return (
    <div className="single_course">
      <div className="course_header">
        <div className="course_header_left">
          <p className="course_overline">{session} · {semester === "1" ? "First Semester" : "Second Semester"}</p>
          <h2>{code.toUpperCase()} <span>{title}</span></h2>
          <p className="course_unit">Unit Load: {unit}</p>
        </div>
        <div className="course_upload_row">
          <label className="course_file_label">
            {data?.length > 0 ? `${data.length} rows loaded` : "Choose Excel file"}
            <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} style={{ display: "none" }} />
          </label>
          <button className="course_upload_btn" onClick={handle_result_upload}>
            Upload Scores
          </button>
        </div>
      </div>
      {load && <Loader />}
      {!load && students.length === 0 && (
        <div style={{ textAlign: "center", padding: "3rem 1rem", color: "#94a3b8", fontSize: "0.88rem" }}>
          No results uploaded for this course yet.
        </div>
      )}
      {students.length > 0 && (
        <Table
          students={students}
          session={session}
          semester={semester}
          code={code}
        />
      )}
    </div>
  );
}

export default OtherCourse;
